var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 368,
    viewBox: "0 0 210 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.932 39.2032C135.932 105.603 148 118.203 156.932 119.703C205.275 127.822 224.932 51.7032 280.932 100.203C336.932 148.703 330.432 411.703 209.432 361.203C88.4321 310.703 83.4321 249.703 73.4321 225.703C65.4321 206.503 39.7655 184.037 27.9322 175.203C-26.8678 126.803 11.4322 58.3699 37.4322 30.2032C59.7655 5.53652 107.932 -27.1968 121.932 39.2032Z",
    fill: "url(#paint0_linear_2_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_34",
    x1: 118,
    y1: -0.296816,
    x2: 51.686,
    y2: 332.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40AF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeBottom);
export default __webpack_public_path__ + "static/media/shape-bottom.797818fe0fe1454ac7f0cb03dc1bb104.svg";
export { ForwardRef as ReactComponent };